/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: BUSL-1.1
 */

/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vault Reporting
 * API for Vault Reporting
 *
 * The version of the OpenAPI document: 2025-05-05
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.ts';
import type { VaultReporting20250505SecretsInventoryRow } from './VaultReporting20250505SecretsInventoryRow.ts';
import {
    VaultReporting20250505SecretsInventoryRowFromJSON,
    VaultReporting20250505SecretsInventoryRowFromJSONTyped,
    VaultReporting20250505SecretsInventoryRowToJSON,
    VaultReporting20250505SecretsInventoryRowToJSONTyped,
} from './VaultReporting20250505SecretsInventoryRow.ts';
import type { CommonPaginationResponse } from './CommonPaginationResponse.ts';
import {
    CommonPaginationResponseFromJSON,
    CommonPaginationResponseFromJSONTyped,
    CommonPaginationResponseToJSON,
    CommonPaginationResponseToJSONTyped,
} from './CommonPaginationResponse.ts';

/**
 * 
 * @export
 * @interface VaultReporting20250505FetchSecretsInventoryResponse
 */
export interface VaultReporting20250505FetchSecretsInventoryResponse {
    /**
     * 
     * @type {Array<VaultReporting20250505SecretsInventoryRow>}
     * @memberof VaultReporting20250505FetchSecretsInventoryResponse
     */
    data?: Array<VaultReporting20250505SecretsInventoryRow>;
    /**
     * 
     * @type {Date}
     * @memberof VaultReporting20250505FetchSecretsInventoryResponse
     */
    reportAsOf?: Date;
    /**
     * 
     * @type {CommonPaginationResponse}
     * @memberof VaultReporting20250505FetchSecretsInventoryResponse
     */
    pagination?: CommonPaginationResponse;
}

/**
 * Check if a given object implements the VaultReporting20250505FetchSecretsInventoryResponse interface.
 */
export function instanceOfVaultReporting20250505FetchSecretsInventoryResponse(value: object): value is VaultReporting20250505FetchSecretsInventoryResponse {
    return true;
}

export function VaultReporting20250505FetchSecretsInventoryResponseFromJSON(json: any): VaultReporting20250505FetchSecretsInventoryResponse {
    return VaultReporting20250505FetchSecretsInventoryResponseFromJSONTyped(json, false);
}

export function VaultReporting20250505FetchSecretsInventoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaultReporting20250505FetchSecretsInventoryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(VaultReporting20250505SecretsInventoryRowFromJSON)),
        'reportAsOf': json['report_as_of'] == null ? undefined : (new Date(json['report_as_of'])),
        'pagination': json['pagination'] == null ? undefined : CommonPaginationResponseFromJSON(json['pagination']),
    };
}

export function VaultReporting20250505FetchSecretsInventoryResponseToJSON(json: any): VaultReporting20250505FetchSecretsInventoryResponse {
    return VaultReporting20250505FetchSecretsInventoryResponseToJSONTyped(json, false);
}

export function VaultReporting20250505FetchSecretsInventoryResponseToJSONTyped(value?: VaultReporting20250505FetchSecretsInventoryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(VaultReporting20250505SecretsInventoryRowToJSON)),
        'report_as_of': value['reportAsOf'] == null ? undefined : ((value['reportAsOf']).toISOString()),
        'pagination': CommonPaginationResponseToJSON(value['pagination']),
    };
}

